import "./style.sass";
import assets from "../../assets";

export const DescriptiveProcessing = () => {
  return (
    <section className="processing-page">
      {/* Top Icon */}
      <section className="top-icon">
        <img src={assets.ic_progress} alt="progress" />{" "}
      </section>

      {/* Heading */}
      <h2>Processing Your Answer Sheet</h2>
      <p className="subtitle">
        Kindly wait, we're processing and evaluating your answer
      </p>
      {/* Simple Loading Screen */}
      <div className="simple-loader"></div>
    </section>
  );
};
